export class VehicleUtils {
  public static readonly VEHICLE_LETTERS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  public static readonly NOT_AVAILABLE = 'NOT_AVAILABLE';
  
  public static getVehicleLetters(): string[] {
    return this.VEHICLE_LETTERS.split('');
  }
  
  public static getVehicleLetter(index: number): string {
    return this.VEHICLE_LETTERS[index] || '';
  }
}